module.exports = __webpack_public_path__ + "img/slider_postgres.213b6908.png";